import * as React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { Observer } from 'mobx-react-lite'

interface Props {
  draggableId: string
  position: number
}

export const DraggableItem = (props: React.PropsWithChildren<Props>) => {
  const { draggableId, position, children } = props

  return (
    <Draggable key={draggableId} draggableId={draggableId} index={position}>
      {/* NOTE: using any because of type incompatibility and project is now in maintenance: https://github.com/atlassian/react-beautiful-dnd/issues/2116 */}
      {(provided: any, snapshot) => (
        <Observer>
          {() => (
            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
              {children}
            </div>
          )}
        </Observer>
      )}
    </Draggable>
  )
}
